module.exports = __webpack_public_path__ + "static/media/mls.ad77d2c7.svg";